module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content content--onepane"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-side"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.name),
      expression: "formData.name"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.title),
      expression: "formData.title"
    }],
    staticClass: "form-text",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveNote($event)
      }
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "form-belly"
  }, [_c('longform-editor', {
    attrs: {
      "placeholder": "Notes"
    },
    model: {
      value: (_vm.formData.body),
      callback: function($$v) {
        _vm.formData.body = $$v
      },
      expression: "formData.body"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-25faaef2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newnote.vue
// module id = 65
// module chunks = 0